import { inject, Injectable } from '@angular/core';
import { QueryOptions } from '@orderna/admin-panel/src/types/query-options';
import { IAllTransactionsApiService } from './all-transactions-api.interface';
import { TransactionsApiService } from '../../../transactions/transactions-api.service';
import { Observable } from 'rxjs';
import { AllTransaction } from '../../../../model/all-transaction';
import { Paginated } from '@orderna/admin-panel/src/types/pagination';

@Injectable({
  providedIn: 'root',
})
export class AllTransactionsMockApiService
  implements IAllTransactionsApiService
{
  private transactionsService = inject(TransactionsApiService);

  getAllTransactions(options: QueryOptions<AllTransaction>): Observable<Paginated<AllTransaction>> {
    throw new Error('Method not implemented.');
  }
}
